<template>
  <div>
    <div v-if="addUpdate">
      <!--      <StoppageAddUpdate v-bind:stoppageId="stoppageId" @close="close" @getAllStoppages="getAllStoppages"/>-->
      <StoppageAddUpdateModal
        v-bind:stoppage="stoppageId"
        v-bind:company="pagination.companyId"
        @close="close"
        @getAllStoppages="getAllStoppages"
      />
    </div>
    <div v-if="boardingPlace">
      <BoardingPlace
        v-bind:stoppageId="stoppageId"
        @close="close"
        @toggle="toggle"
      />
    </div>
    <div v-else-if="droppingPlace">
      <DroppingPlace
        v-bind:stoppageId="stoppageId"
        @close="close"
        @toggle="toggle"
      />
    </div>
    <div v-else>
      <FilterTab>
        <!-- <template v-slot:title><h6>Stoppage</h6></template> -->
        <template v-slot:body>
          <div class="col-sm-6 col-md-2"></div>
        </template>
        <template v-if="hasPermission(Owner.stoppageWrite)" v-slot:button1>
          <button class="edit_table_data font_detail" @click="addModal">
            <i class="fas fa-plus"></i
            ><span class="mx-1 bold">{{
              t("Add_new", {}, { locale: $store.getters.getLang })
            }}</span>
          </button>
        </template>
      </FilterTab>
      <Table v-if="$store.getters.getOwnerServicesStopageList">
        <template v-slot:header>
          <tr>
            <td class="font_detail">
              {{ t("SL", {}, { locale: $store.getters.getLang }) }}
            </td>
            <td class="font_detail">
              {{ t("Sequence", {}, { locale: $store.getters.getLang }) }}
            </td>

            <td class="font_detail">
              {{ t("NAME", {}, { locale: $store.getters.getLang }) }}
            </td>
            <td class="font_detail">
              {{ t("BoardingPlace", {}, { locale: $store.getters.getLang }) }}
            </td>
            <td class="font_detail">
              {{ t("DroppingPlace", {}, { locale: $store.getters.getLang }) }}
            </td>
            <td class="font_detail">
              {{ t("STATUS", {}, { locale: $store.getters.getLang }) }}
            </td>

            <td v-if="hasPermission(Owner.stoppageWrite)" class="font_detail">
              {{ t("ACTION", {}, { locale: $store.getters.getLang }) }}
            </td>
          </tr>
        </template>
        <template v-slot:body>
          <tr
            v-for="(stoppage, index) in $store.getters
              .getOwnerServicesStopageList"
            :key="stoppage._id"
          >
            <td class="font_detail">
              {{ index + 1 + (pagination.page - 1) * 25 }}
            </td>
            <td class="font_detail">#{{ stoppage.sequence }}</td>

            <td class="font_detail">{{ stoppage.name }}</td>
            <td class="font_detail">
              <button
                class="edit_table_data font_detail add_table_button px-2"
                @click="updateBoardingPlace(stoppage._id)"
              >
                <i class="fas fa-map-marker-alt"></i
                ><span class="mx-1">{{
                  t("Create", {}, { locale: $store.getters.getLang })
                }}</span>
              </button>
            </td>
            <td class="font_detail">
              <button
                class="edit_table_data font_detail add_table_button px-2"
                @click="updateDroppingPlace(stoppage._id)"
              >
                <i class="fas fa-map-marker-alt"></i
                ><span class="mx-1">{{
                  t("Create", {}, { locale: $store.getters.getLang })
                }}</span>
              </button>
            </td>
            <td>
              <span v-if="stoppage.status" class="badge bg-success">{{
                dropdownVariables.status[1]
              }}</span>
              <span v-else class="badge bg-danger">{{
                dropdownVariables.status[0]
              }}</span>
            </td>

            <td v-if="hasPermission(Owner.stoppageWrite)">
              <button
                class="edit_table_data font_detail edit_table_button"
                @click="updateModal(stoppage._id)"
              >
                <i class="fas fa-edit"></i
                ><span class="mx-1">{{
                  t("Edit", {}, { locale: $store.getters.getLang })
                }}</span>
              </button>
            </td>
          </tr>
        </template>
        <template v-slot:pagination>
          <pagination
            v-model="pagination.page"
            :records="$store.getters.getTotalStopageRecords"
            :per-page="pagination.limit"
            @paginate="getAllStoppages"
            :options="options"
          />
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { reactive } from "@vue/reactivity";
import { inject, onBeforeMount, ref } from "vue";
import store from "@/store";
import dropdownVariables from "@/modules/dropdownVariables";
import StoppageAddUpdateModal from "./StoppageAddUpdateModal";
import permission from "@/modules/permission";
import roles from "@/modules/roles";
import BoardingPlace from "./BoardingPlace/BoardingPlace.vue";
import DroppingPlace from "./DroppingPlace/DroppingPlace";
import { useI18n } from "vue-i18n";
const { hasPermission } = permission();
const { Owner } = roles();

export default {
  name: "Stoppage",
  components: { StoppageAddUpdateModal, BoardingPlace, DroppingPlace },
  setup() {
    let pagination = reactive({
      page: 1,
      limit: 25,
      companyId: "",
    });
    const addUpdate = ref(false);
    const stoppageId = ref("");
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const { t, locale } = useI18n();
    const options = {
      texts: {
        count: "",
      },
    };
    const boardingPlace = ref(false);
    const droppingPlace = ref(false);

    const updateBoardingPlace = (id) => {
      stoppageId.value = id;
      boardingPlace.value = true;
    };
    const updateDroppingPlace = (id) => {
      stoppageId.value = id;
      droppingPlace.value = true;
    };
    const toggle = () => {
      stoppageId.value = "";
      if (boardingPlace.value || droppingPlace.value) {
        boardingPlace.value = false;
        droppingPlace.value = false;
      } else {
        addUpdate.value = !addUpdate.value;
      }
    };
    const getAllStoppages = () => {
      showLoader();
      store
        .dispatch("getOwnerServicesStopageByPage", pagination)
        .then(() => {
          hideLoader();
        })
        .catch((error) => {
          hideLoader();
          if (error.status === 401) {
            getAllStoppages();
          }
        });
    };
    const close = () => {
      addUpdate.value = false;
    };
    const addModal = () => {
      stoppageId.value = "";
      addUpdate.value = true;
    };
    const updateModal = (id) => {
      stoppageId.value = id;
      addUpdate.value = true;
    };

    onBeforeMount(() => {
      getAllStoppages();
      // if (route.query.id) {
      //   pagination.companyId = route.query.id;
      //   getAllStoppages();
      // }
    });

    return {
      t,
      locale,
      options,
      pagination,
      dropdownVariables,
      addUpdate,
      stoppageId,

      hasPermission,
      getAllStoppages,
      addModal,
      updateModal,
      close,
      Owner,
      updateBoardingPlace,
      updateDroppingPlace,
      toggle,
      boardingPlace,
      droppingPlace,
    };
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
